import React, { useEffect } from "react";
import MasonryGallary from "../components/Gallary/MasonaryGallary";
import { Loader } from "../components/common/Loader";
import { useAppDispatch, useAppSelector } from "../Hooks";
import { getGalleryData } from "../features/Gallery";
import { Banner } from "../components/common/Banner";

const Gallery: React.FC<{ banner_title: string }> = ({ banner_title }) => {
    const dispatch = useAppDispatch();
    const { gallery, galleryLoader, status } = useAppSelector(state => state.gallery);

    useEffect(() => {
        dispatch(getGalleryData());
    }, [status, dispatch]);

    if (galleryLoader) {
        return <Loader />;
    }
    return (
        <>
            <Banner banner_title={banner_title} />
            <MasonryGallary images={gallery} />
        </>
    )
}
export default Gallery;